module.exports = __webpack_public_path__ + "img/cultive_vue.692cd239.jpg";